import {GroupDto, UserDto} from '../../scaffold';

export default function GroupKeywordFilter(Group: GroupDto, keyword: string) {
  return (Group.name || '').includes(keyword);
}
